export default "__VITE_PUBLIC_ASSET__07b78b40__"